import { createPublicClient, http, } from "viem";
import { publicActionsL2 } from "viem/op-stack";
import { facetMainnet, facetSepolia } from "./chains";
export const createFacetPublicClient = (l1ChainId) => {
    return createPublicClient({
        chain: l1ChainId === 1 ? facetMainnet : facetSepolia,
        transport: http(),
    }).extend(publicActionsL2());
};
